import React, { useState, useEffect, useCallback } from 'react';
import { auth, firestore } from '../Firebase/FirebaseConfig';
import { collection, getDocs } from "firebase/firestore";
import { getProfilePictureUrl } from '../firebasehelpers/getProfilePictureUrl';
import '../styles/ProfileView.css';

const ProfileView = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [profilePicUrl, setProfilePicUrl] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [userName, setUserName] = useState('');

    const fetchPosts = useCallback(async () => {
        if (!userEmail) return;
        setLoading(true);
        try {
            const newPosts = [];            
            const postsCollection = collection(firestore, `users/${userEmail}/posts`);
            const postsSnapshot = await getDocs(postsCollection);
            postsSnapshot.forEach((doc) => {
                const postData = { id: doc.id, ...doc.data() };
                // Convert and sort dates here if needed
                newPosts.push(postData);
            });

            newPosts.forEach((post) => {
                const dateString = post.postedDate;
                const formattedDateString = dateString.replace(" at ", " ");
                const dateObject = new Date(formattedDateString);
            
                console.log(dateObject); // This will be a Date object representing your date
                post.date = dateObject;
            });
          
              // Sort posts by date
            newPosts.sort((a, b) => b.date - a.date);
            setPosts(newPosts);
        } catch (error) {
            console.error('Error fetching posts:', error);
        } finally {
            setLoading(false);
        }
    }, [userEmail]);

    useEffect(() => {
        const user = auth.currentUser;
        if (user) {
            setUserEmail(user.email.replace(/\./g, "-").replace("@", "-")); // Replace '.' with '-', Replace '@' with '-');
            setUserName(user.displayName || user.email.split("@")[0]);
            // Here, fetch the profile picture URL and call fetchPosts
            getProfilePictureUrl(userEmail).then(url => setProfilePicUrl(url));
            fetchPosts(); // This should be called after setting userEmail
        }
    }, [userEmail, fetchPosts]); // Add fetchPosts as a dependency

    if (loading) {
        return <div>Loading posts...</div>;
    }

    return (
        <div className="profile-container">
            {/* User profile details */}
            <div className="profile-header">
                <div className="user-profile">
                    {profilePicUrl 
                        ? <img src={profilePicUrl} alt="Profile" className="profile-pic" />
                        : <p>No profile picture</p>
                    }
                </div>
                <h2 className="profile-username">{userName}</h2>
            </div>
            <p><b>Posts</b></p>
            <div className="profile-posts">
                {posts.map(post => (
                    <div key={post.id} className="profile-post">
                        {post.postURLString && <img src={post.postURLString} alt={post.caption} />}
                        {/* Render other post details */}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProfileView;

